import React, { useEffect, useState } from 'react';
import { CareerCategoryList, SkillCategoryList } from './ListComponents';
import './styles.scss';
import { CareersApi } from 'global/api';
import {
  CategoryWithCareers,
  CategoryWithSkills,
  SkillWithCareers,
} from 'labxchange-client';
import { intl } from 'i18n';
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  ceMapLoading: {
    id: 'ceMapLoading',
    defaultMessage: 'Loading',
    description: 'text for showing loading state',
  },
  ceMapExploreCareersBySkills: {
    id: 'ceMapExploreCareersBySkills',
    defaultMessage: 'Explore Careers by Skills',
    description: 'text for showing Explore Careers by Skills',
  },
  ceMapExploreSkillsByCareers: {
    id: 'ceMapExploreSkillsByCareers',
    defaultMessage: 'Explore Skills by Careers',
    description: 'text for showing Explore Skills by Careers',
  },
  ceMapSkillsMap: {
    id: 'ceMapSkillsMap',
    defaultMessage: 'Skills Map',
    description: 'text for showing Skills Map',
  },
  ceMapCareersMap: {
    id: 'ceMapCareersMap',
    defaultMessage: 'Careers Map',
    description: 'text for showing Careers Map',
  },
});

const SkillsMapByCategory: React.FC = () => {
  const [data, setData] = useState<CategoryWithSkills[] | SkillWithCareers[]>(
    []
  );
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState<'careerSkills' | 'skillCareers'>(
    'careerSkills'
  );

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        if (view === 'careerSkills') {
          const result = await CareersApi.careersBySkillsList({});
          setData(result);
        } else {
          const result = await CareersApi.skillsByCareersList({});
          setData(result);
        }
      } catch (error) {
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [view]);

  return (
    <div className='career-skills-map'>
      {view === 'careerSkills' ? (
        <h2>{intl.formatMessage(messages.ceMapExploreCareersBySkills)}</h2>
      ) : (
        <h2>{intl.formatMessage(messages.ceMapExploreSkillsByCareers)}</h2>
      )}

      <div className='toggle-switch'>
        <button
          className={view === 'careerSkills' ? 'active' : ''}
          onClick={() => setView('careerSkills')}
        >
          {intl.formatMessage(messages.ceMapSkillsMap)}
        </button>
        <button
          className={view === 'skillCareers' ? 'active' : ''}
          onClick={() => setView('skillCareers')}
        >
          {intl.formatMessage(messages.ceMapCareersMap)}
        </button>
      </div>

      {loading ? (
        <p>{intl.formatMessage(messages.ceMapLoading)}</p>
      ) : view === 'careerSkills' ? (
        <CareerCategoryList categories={data as CategoryWithSkills[]} />
      ) : (
        <SkillCategoryList categories={data as CategoryWithCareers[]} />
      )}
    </div>
  );
};

export default SkillsMapByCategory;
